export default __webpack_public_path__ + "static/media/sound_christmastree.8ebe2c1b.wav";